import { useFlag } from 'utils/launchdarkly';

export const useIsEditCartEnabled = ({ cartHasIncentive }: { cartHasIncentive?: boolean } = {}) => {
  const enableEditCart = useFlag('enable-edit-cart');
  const enableOffersEditCart = useFlag('enable-offers-edit-cart');
  return cartHasIncentive ? enableEditCart && enableOffersEditCart : enableEditCart;
};
